<div class="navblock hidden-print">
  <button (click)="openCreateModal()" class="btnadd">{{ 'Add group' | translate }}</button>
  <div class="inputgroup">
    <input class="searchinput"
           type="text"
           placeholder="{{ 'Find by name' | translate }}"
           [(ngModel)]="nameFilter"
           (input)="onTermChange($event)" />
  </div>
  <div class="company-filter">
    <p-multiselect [options]="companies" [(ngModel)]="selectedCompanyIds"
      (ngModelChange)="onCompanyFilterChange($event)"
      optionLabel="Name" optionValue="Id" [filter]="true"
      filterBy="Name" [showClear]="true" [appendTo]="'body'"
      styleClass="objects-company-multiselect"
      panelStyleClass="objects-company-multiselect-panel"
      [placeholder]="'All companies' | translate">
    </p-multiselect>
  </div>
</div>

<div class="tablewrap">
  <div class="table">
    <table fixedcols="[0, 4]" id="exporttable">
      <tr>
        <th class="hidden-print">
          <switch-all-checkbox [items]="filteredGroups" />
        </th>
        <th>{{ 'Name' | translate }}</th>
        <th>{{ 'Company' | translate }}</th>
        <th>{{ 'Objects' | translate }}</th>
        <th>{{ 'Users' | translate }}</th>
        <th class="hidden-print">&nbsp;</th>
      </tr>
      <tr *ngFor="let group of filteredGroups | pagesfilter: pageInfoFilter; trackBy: trackByGroupId">
        <td class="hidden-print">
          <input type="checkbox" [(ngModel)]="group.IsChecked" />
        </td>
        <td>{{ group.Name }}</td>
        <td>{{ getCompanyName(group.CompanyId) }}</td>
        <td>{{ group.objects?.length ?? 0 }}</td>
        <td>
          <span *ngIf="!group.Users?.length" class="no-users">{{ 'No users' | translate }}</span>
          <span *ngIf="group.Users?.length">{{ getUserNamesString(group.Users) }}</span>
        </td>
        <td class="hidden-print">
          <button class="btn_img btn_edit"
                  title="{{ 'Edit' | translate }}"
                  (click)="openEditModal(group)"></button>
          <button class="btn_img btn_trush"
                  title="{{ 'Delete' | translate }}"
                  (click)="deleteObject(group.Id)"></button>
        </td>
      </tr>
    </table>
  </div>
</div>

<app-footer-component
  (onDeleteSelected)="deleteSelected()"
  [viewMode]="'print excel pages'"
  (onPageChange)="onPageChange($event)"
  [items]="filteredGroups">
</app-footer-component>

<app-object-group-access
  [objects]="liteObjects"
  (groupsChanged)="onGroupsChanged()">
</app-object-group-access>

<template #mgmtDialog></template>
